var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-view-container"},[_c('div',{staticClass:"e404-code"},[_vm._v(" 404! ")]),_c('div',{staticClass:"e404-info"},[_vm._v(" Strony nie znaleziono! :( ")])])
}]

export { render, staticRenderFns }